import { forwardRef, InjectionToken, Provider, Type } from '@angular/core';
import { ContentModel } from '@libs/cms/models';

export interface TrackingDataFields {
  id?: string | number | null;
  name?: string | null;
  type?: string | null;
  personalizationSegment?: string;
}

export interface ContentTrackingContext {
  data: () => ContentModel;
}

export interface ContentTrackingData {
  data: () => TrackingDataFields;
}

export const CONTENT_TRACKING_CONTEXT: InjectionToken<ContentTrackingContext> = new InjectionToken<ContentTrackingContext>('CONTENT_TRACKING_CONTEXT');
export const CONTENT_TRACKING_DATA: InjectionToken<ContentTrackingData> = new InjectionToken<ContentTrackingData>('CONTENT_TRACKING_DATA');

export const provideContentTrackingContext = (type: Type<ContentTrackingContext>): Provider => ({
  provide: CONTENT_TRACKING_CONTEXT,
  useExisting: forwardRef(() => type),
});

export const provideContentTrackingData = (type: Type<ContentTrackingData>): Provider => ({
  provide: CONTENT_TRACKING_DATA,
  useExisting: forwardRef(() => type),
});
